import React from 'react';
import MoveControls from './MoveControls';
import { FaMinusCircle } from 'react-icons/fa';
import { RandomId } from '@swivl-mono/helpers';


interface Props {
  deleteValue(name: string, index: number): void;
  addItemToArray(data: any, arrayName: string, isObject: boolean): void;

  card: any;
  cards: any;
  arrayIndex: number;
  onChange(event: any): void;
  onChangeUpdate(event: any): void;
}
export default class InspectorCarouselCard extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.deletePressed = this.deletePressed.bind(this);
    this.deleteButton = this.deleteButton.bind(this);
    this.addButton = this.addButton.bind(this);
  }
  deletePressed() {
    this.props.deleteValue('cards', this.props.arrayIndex);
  }

  addButton(event: any) {
    const buttonId = RandomId(6);
    let buttonData = {
      text: 'New Button',
      id: buttonId,
      cardId: this.props.card.id,
      onSelectGoto: null,
      payload: buttonId,
    };
    var arrayName = 'cards.' + this.props.arrayIndex + '.actions';
    this.props.addItemToArray(buttonData, arrayName, true);
  }

  deleteButton(event: any) {
    var buttonIndex = event.target.id;
    var arrayName = 'cards.' + this.props.arrayIndex + '.actions';
    this.props.deleteValue(arrayName, buttonIndex);
  }

  render() {
    var self = this;
    let carouselButtons, addButton;
    var titleDisplay = this.props.arrayIndex + 1;

    if (this.props.card.actions) {
      carouselButtons = this.props.card.actions.map(function (
        action: any,
        index: any
      ) {
        // var goToPath = self.props.card.actions[index].onSelectGoto;

        if (action.displayText) {
          console.warn('removing old displayText');
          delete action.displayText; // this is to remove old redundant data
        }
        return (
          <div key={index} className="cardButton">
            <input
              className="carouselButtonTitle"
              value={action.text}
              name={
                'cards.' + self.props.arrayIndex + '.actions.' + index + '.text'
              }
              onChange={self.props.onChange}
            />
            <span
              className="deleteButtonIcon"
              onClick={self.deleteButton}
              id={index}
            >
              <FaMinusCircle />
            </span>
          </div>
        );
      });
    }

    addButton =
      this.props.card.actions.length > 2 ? null : (
        <div
          className="addElementButton addCardButton"
          id="carouselAddCard"
          onClick={this.addButton}
        >
          + ADD BUTTON
        </div>
      );

    return (
      <div className="InspectorCarouselCard" key={this.props.arrayIndex}>
        <div className="carouselCardHeader">
          {/* <div className="carouselMoveControls"><MoveControls arrayIndex={this.props.arrayIndex} arrayName="cards" /></div> */}
          <span className="carouselTitle">Carousel Item {titleDisplay}</span>
          <span
            className="deleteButtonIcon carouselCardDelete"
            onClick={this.deletePressed}
          >
            <FaMinusCircle />
          </span>
        </div>
        <div className="cardContent">
          <input
            className="carouselInput"
            placeholder="Image URL"
            value={this.props.card.mediaUrl}
            name={'cards.' + this.props.arrayIndex + '.mediaUrl'}
            onChange={this.props.onChangeUpdate}
          />
          <input
            className="carouselInput"
            placeholder="Title"
            value={this.props.card.title}
            name={'cards.' + this.props.arrayIndex + '.title'}
            onChange={this.props.onChange}
          />
          <input
            className="carouselInput"
            placeholder="Description"
            value={this.props.card.description}
            name={'cards.' + this.props.arrayIndex + '.description'}
            onChange={this.props.onChange}
          />
          {carouselButtons}
          {addButton}
        </div>
      </div>
    );
  }
}
